"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBChatNegative = function SvgBChatNegative(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M97.393 100.449a52.346 52.346 0 01-18.643-3.372 2.108 2.108 0 111.497-3.94 48.805 48.805 0 0037.355-1.3 2.109 2.109 0 011.785 3.821 52.346 52.346 0 01-21.994 4.79z"
  }), (0, _core.jsx)("path", {
    d: "M127.717 113.795a5.337 5.337 0 01-2.704-.737l-11.007-6.428a2.107 2.107 0 112.107-3.638l11.028 6.406a1.145 1.145 0 001.714-1.138l-2.634-20.455a2.107 2.107 0 01.738-1.883c8.176-6.855 12.686-16.008 12.686-25.772 0-8.998-3.906-17.617-10.993-24.276-7.088-6.66-16.859-10.84-27.311-11.668a2.114 2.114 0 11.337-4.215c11.436.907 22.043 5.451 29.86 12.792 7.945 7.446 12.322 17.16 12.322 27.332 0 10.677-4.72 20.665-13.347 28.245L133 107.726a5.38 5.38 0 01-5.318 6.048l.035.021zM81.989 25.288a2.107 2.107 0 01-.45-4.166 53.385 53.385 0 017.362-1.173 2.114 2.114 0 01.33 4.215c-2.285.22-4.552.595-6.786 1.124a2.592 2.592 0 01-.456 0zM63.676 90.488c-.384 0-.76-.104-1.089-.302-.45-.274-.941-.576-1.46-.913a23.525 23.525 0 01-2.122-1.602l-.977-.765a2.107 2.107 0 012.53-3.316l1.046.83c.64.512 1.187.947 1.798 1.348.485.309.941.59 1.356.843a2.107 2.107 0 01-1.082 3.912v-.035z"
  }), (0, _core.jsx)("path", {
    d: "M56.982 100.449a62.11 62.11 0 01-32.572-9.005 2.108 2.108 0 012.205-3.59 57.902 57.902 0 0030.367 8.38c29.088 0 52.76-20.638 52.76-46.003a40.65 40.65 0 00-3.898-17.378 2.107 2.107 0 013.814-1.791 44.844 44.844 0 014.299 19.17c0 27.676-25.562 50.217-56.975 50.217z"
  }), (0, _core.jsx)("path", {
    d: "M16.388 117.497a5.367 5.367 0 01-5.318-6.048l3.513-27.655C5.184 74.557 0 62.672 0 50.217 0 22.527 25.562 0 56.982 0c18.165 0 35.403 7.727 46.1 20.694a2.108 2.108 0 01-3.251 2.683C89.912 11.38 73.904 4.215 56.98 4.215c-29.094 0-52.766 20.637-52.766 46.002 0 11.598 5.001 22.724 14.048 31.266.493.463.733 1.135.647 1.805l-3.688 28.709a1.145 1.145 0 001.742 1.096l16.563-9.673a2.107 2.107 0 112.108 3.639l-16.543 9.7a5.367 5.367 0 01-2.704.738z"
  }), (0, _core.jsx)("path", {
    d: "M75.323 40.692H35.515a2.107 2.107 0 110-4.214h39.808a2.107 2.107 0 110 4.214zM75.323 53.926H35.515a2.107 2.107 0 110-4.214h39.808a2.107 2.107 0 110 4.214zM62.046 67.21H35.564a2.107 2.107 0 110-4.215h26.482a2.107 2.107 0 110 4.214z"
  })));
};

var _default = SvgBChatNegative;
exports["default"] = _default;